var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "data-test": "outside-vif"
    }
  }, [_vm.step === 1 ? [_c('p', [_vm._v("\n      The following are results manually entered by users and not verified in\n      the database. Adding a chemical not matched to the database has\n      consequences for accuracy of regulatory reports.\n    ")]), _vm._v(" "), _vm.isBusy ? _c('raft-busy', {
    attrs: {
      "busy-text": "Searching unlinked chemicals..."
    }
  }) : _vm._e(), _vm._v(" "), _c('b-radio-group', {
    attrs: {
      "id": "local_unlinked_search_results"
    }
  }, [_c('b-radio', {
    attrs: {
      "value": "_none_",
      "name": "unlinked_chemicals",
      "data-test": "unlinked-none"
    },
    model: {
      value: _vm.selectedLocalSearchResult,
      callback: function ($$v) {
        _vm.selectedLocalSearchResult = $$v;
      },
      expression: "selectedLocalSearchResult"
    }
  }, [_vm._v("\n        --None of the above--\n      ")]), _vm._v(" "), _vm._l(_vm.localSearchResults, function (option) {
    return _c('b-radio', {
      key: option.id,
      attrs: {
        "value": option.id,
        "name": "unlinked_chemicals"
      },
      model: {
        value: _vm.selectedLocalSearchResult,
        callback: function ($$v) {
          _vm.selectedLocalSearchResult = $$v;
        },
        expression: "selectedLocalSearchResult"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.formatUnlinkedChemicalLabel(option)) + "\n      ")]);
  })], 2)] : _vm._e(), _vm._v(" "), _vm.step === 2 ? [_c('p', {
    staticClass: "unlinked-chem-wiz-content"
  }, [_vm._v("\n      Are you sure this chemical is not listed under a different name or CAS\n      number? Adding a chemical not matched to the database has consequences\n      for the accuracy of regulatory reports.\n    ")])] : _vm._e(), _vm._v(" "), _vm.step === 3 ? [_c('div', {
    attrs: {
      "id": "unlinked-chemical-form"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Add Unlinked Chemical",
      "label-for": "chemical-name"
    }
  }, [_c('b-form-row', [_c('label', {
    staticClass: "required",
    attrs: {
      "id": "chemical-name",
      "for": "chemical-name",
      "title": "This field is required."
    }
  }, [_vm._v("Chemical name"), _c('sup', [_vm._v("*")]), _vm._v(":")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "text",
      "name": "chemical-name"
    },
    model: {
      value: _vm.chemicalName,
      callback: function ($$v) {
        _vm.chemicalName = $$v;
      },
      expression: "chemicalName"
    }
  })], 1), _vm._v(" "), _c('b-form-row', [_c('label', {
    attrs: {
      "for": "cas-number"
    }
  }, [_vm._v("CAS number:")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "text",
      "name": "cas-number"
    },
    model: {
      value: _vm.casNumber,
      callback: function ($$v) {
        _vm.casNumber = $$v;
      },
      expression: "casNumber"
    }
  })], 1), _vm._v(" "), _c('b-form-row', [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "physical-state"
    }
  }, [_vm._v("Physical state"), _c('sup', [_vm._v("*")]), _vm._v(":")]), _vm._v(" "), _c('b-select', {
    attrs: {
      "name": "physical-state",
      "options": _vm.physicalStates
    },
    model: {
      value: _vm.physicalState,
      callback: function ($$v) {
        _vm.physicalState = $$v;
      },
      expression: "physicalState"
    }
  })], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "unlinked-chemical-wizard-controls"
    }
  }, [_vm.step === 1 ? _c('a', {
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel-add-unlinked-chemical');
      }
    }
  }, [_vm._v("Return to chemical search")]) : _vm._e(), _vm._v(" "), _vm.step > 1 ? _c('b-button', {
    on: {
      "click": _vm.previousStep
    }
  }, [_vm._v(" Back ")]) : _vm._e(), _vm._v(" "), _vm.step <= 3 ? _c('b-button', {
    attrs: {
      "data-test": "nextButton"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n      " + _vm._s(_vm.nextButtonLabel) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.isBusy ? _c('raft-busy', {
    attrs: {
      "busy-text": ""
    }
  }) : _vm._e()], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }